module.exports = __webpack_public_path__ + "img/ss1.b86cfb04.gif";